import { render, staticRenderFns } from "./refuel-detail.vue?vue&type=template&id=2c5a3776&scoped=true"
import script from "./refuel-detail.vue?vue&type=script&lang=js"
export * from "./refuel-detail.vue?vue&type=script&lang=js"
import style0 from "./refuel-detail.vue?vue&type=style&index=0&id=2c5a3776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5a3776",
  null
  
)

export default component.exports